import Tooltip from '@creditflowresearch/uilib/Tooltip';
import { getAndFormatDateFromString } from '@/condor/ui/common/Layout/helpers';
import { MONTH_DAY_YEAR_FORMAT as formatString } from '@dealroadshow/uikit-date-time/dateFormats';
import { IDatetime } from '@framework/date-helpers/Datetime';
import type IDealCellData from '@/creditflowresearch/ui/components/deals/DealListTable/cells/types';

type DateInfo = { date: IDatetime, label: string } | null;

const priorities = [
  { key: 'pricingDate', label: 'Issue Date' },
  { key: 'announcedDate', label: 'Announced Date' },
  { key: 'lastUpdatedDate', label: 'Last Updated Date' },
];
const getDateToDisplay = (dates: {
  pricingDate?: IDatetime | null,
  announcedDate?: IDatetime | null,
  lastUpdatedDate?: IDatetime | null,
}): DateInfo => {
  const entry = priorities.find((p) => dates[p.key as keyof typeof dates]);
  return entry ? { date: dates[entry.key as keyof typeof dates], label: entry.label } : null;
};

export const DealDateCell = ({ row: deal }: { row: IDealCellData }) => {
  const { pricingDate, announcedDate, lastUpdatedDate } = deal;

  const dateInfo = getDateToDisplay({ pricingDate, announcedDate, lastUpdatedDate });

  if (!dateInfo) {
    return '-';
  }

  const { date, label } = dateInfo;

  return (
    <div data-test="dealRowDates">
      <Tooltip content={ label }>
        { getAndFormatDateFromString(date.dateTime, { timeZone: date.timezone, formatString }) }
      </Tooltip>
    </div>
  );
};
